import React from 'react';
import PropTypes from 'prop-types';

export const IconBell = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#icon-bell-clip0_19223_67801)">
      <path
        d="M9.99977 20C11.1987 20 12.2311 19.2758 12.6841 18.2422H7.31543C7.76844 19.2758 8.8009 20 9.99977 20Z"
        fill="url(#icon-bell-paint0_linear_19223_67801)"
      />
      <path
        d="M16.0547 9.68211V8.39844C16.0547 5.67102 14.2418 3.35934 11.7579 2.6043V1.75781C11.7579 0.788555 10.9693 0 10 0C9.03079 0 8.24223 0.788555 8.24223 1.75781V2.6043C5.75825 3.35934 3.94536 5.67098 3.94536 8.39844V9.68211C3.94536 12.0779 3.03216 14.3496 1.37399 16.0788C1.21149 16.2483 1.16583 16.4983 1.25794 16.7143C1.35005 16.9302 1.56216 17.0703 1.79692 17.0703H18.2032C18.4379 17.0703 18.65 16.9302 18.7421 16.7143C18.8342 16.4983 18.7886 16.2483 18.6261 16.0788C16.9679 14.3496 16.0547 12.0779 16.0547 9.68211ZM10.586 2.37219C10.3931 2.35359 10.1977 2.34375 10 2.34375C9.80239 2.34375 9.60696 2.35359 9.41411 2.37219V1.75781C9.41411 1.43473 9.67696 1.17188 10 1.17188C10.3231 1.17188 10.586 1.43473 10.586 1.75781V2.37219Z"
        fill="url(#icon-bell-paint1_linear_19223_67801)"
      />
      <path
        d="M17.6175 8.39866C17.6175 8.72225 17.8798 8.9846 18.2034 8.9846C18.527 8.9846 18.7894 8.72225 18.7894 8.39866C18.7894 6.051 17.8751 3.84385 16.2151 2.18381C15.9863 1.95502 15.6153 1.95499 15.3865 2.18381C15.1576 2.41264 15.1576 2.78362 15.3865 3.01245C16.8252 4.45116 17.6175 6.36401 17.6175 8.39866Z"
        fill="url(#icon-bell-paint2_linear_19223_67801)"
      />
      <path
        d="M1.79687 8.98457C2.12047 8.98457 2.38281 8.72223 2.38281 8.39863C2.38281 6.36402 3.17516 4.45117 4.61383 3.01246C4.84266 2.78363 4.84266 2.41266 4.61383 2.18383C4.38504 1.955 4.01402 1.955 3.7852 2.18383C2.12516 3.84387 1.21094 6.05098 1.21094 8.39863C1.21094 8.72223 1.47328 8.98457 1.79687 8.98457Z"
        fill="url(#icon-bell-paint3_linear_19223_67801)"
      />
    </g>
  </svg>

);

IconBell.propTypes = {
  className: PropTypes.string,
};

IconBell.defaultProps = {
  className: null,
};
